import axios from 'axios'
import {
  checkRes,
  getCookie,
  isMobile
} from '@/module/tools' // 导入工具包
import weui from 'weui.js'

if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

// http-config *
const
  PLATFORM_NAME = localStorage.getItem("platformName") || 'FA'
// 注意这里不同的项目必须改

const baseUrl = process.env.NODE_ENV === 'development' ? process.env.API_URL : window.location.origin
// 获取配置文件中的Url

const timeout = 60000 // 超时时间，单位毫秒

class api {
  /**
   * ajax主函数
   *
   * @param {Object} opt 请求参数，同axios option参数
   * @returns
   *
   * @memberOf api
   */
  ajax(url, opt) {
    const options = Object.assign({
      loading: true, // 默认展示loading图
      timeout,
      url: baseUrl + url,
      withCredentials: true
    }, opt)

    let timer, loading

    // 1秒后仍在请求则loading
    timer = setTimeout(() => {
      if (options.loading) {
        loading = weui.loading('加载中...')
      }
    }, 1000)
    return new Promise((resolve, reject) => {
      axios(options).then(res => {
        // DEBUG 1 打开 0 关闭
        if (process.env.DEBUG === '1') {
          console.log(url, res)
        }
        if (typeof res.data !== 'object' && !res.data.SZ_HEAD) {
          reject('返回值格式不正确')
        }

        // 请求完毕关掉loading
        options.loading = false
        clearTimeout(timer)
        loading && loading.hide()

        if (res.data.SZ_HEAD.RESP_CODE === 'B0205') {
          if (isMobile()) { // 移动端
            // location.href = `https://${location.hostname}/hms/wap/login?ref=${location.href}&${location.search.slice(1)}`
            location.href = `/hms/wap/login${location.search}`
            return
          }
          // location.href = `https://${location.hostname}/hms/web/login?ref=${location.href}&${location.search.slice(1)}`
          location.href = `/hms/web/login${location.search}`
          return
        }

        resolve(res)
      }).catch(error => {
        options.loading = false
        clearTimeout(timer)
        loading && loading.hide()
        reject(error)
      })
    })
  }

  /**
   * get方法
   *
   * @param {String} url 接口地址
   * @param {Object} [params={}] 请求参数，默认为空对象
   * @param {Object} [options={}] 其它配置，同axios option 参数
   * @returns
   *
   * @memberOf api
   */
  get(url, params = {}, options = {}) {
    params._t = new Date().getTime()
    if (!params.platformName) {
      params.platformName = PLATFORM_NAME
    }

    const opt = Object.assign({
      method: 'get',
      params
    }, options)
    return this.ajax(url, opt)
  }

  /**
   * post方法
   *
   * @param {String} url 接口地址
   * @param {Object} [data={}] 请求参数，默认为空对象
   * @param {Object} [options={}] 其它配置，同axios option 参数
   * @returns
   *
   * @memberOf api
   */
  post(url, data = {}, options = {}) {
    data._t = new Date().getTime()
    if (!data.platformName) {
      data.platformName = PLATFORM_NAME
    }

    const opt = Object.assign({
      method: 'post',
      data: {
        ...data,
        _csrf: getCookie('csrfToken')
      }
    }, options)
    return this.ajax(url, opt)
  }

  /**
   * 查询可约地区数据
   *
   * @param {String} orderCode 订单号
   * @return {Object} 可约地区数据
   *
   * @memberOf api
   */
  queryPresetRegions(orderCode) {
    return this.get('/es/hms/query/preset_regions', {
      orderCode
    })
  }

  /**
   * 查询可约机构
   *
   * @return {Object} 可约机构数据
   *
   * @memberOf api
   */
  queryPresetInstits(data) {
    return this.get('/es/hms/query/preset_instits', data)
  }

  /**
   * 查询更多可约日期
   *
   * @param {Object} {orderCode, institCode} 订单号，机构编号
   * @return {Object} 可约日期数据
   *
   * @memberOf api
   */
  queryReserveTime({
    orderCode,
    institCode
  }) {
    return this.get('/es/hms/query/preset_reserve_time', {
      orderCode,
      institCode
    })
  }
  queryReserveTimeGroup({
    orderCode,
    institCode
  }) {
    return this.get('/es/hms/getExamInstitReserveDays', {
      orderCode,
      institCode
    })
  }
  /**
   * 查询订单详情
   *
   * @param {Object} {orderCode, institCode} 订单号，机构编号(可选:用于查询支持性别)
   * @return {Object} 可约日期数据
   *
   * @memberOf api
   */
  queryOrderDetail({
    orderCode,
    institCode,
    addrId
  }) {
    return this.get('/es/hms/query/order_detail', {
      orderCode,
      institCode,
      addrId
    })
  }

  /**
   * 修改预约时间
   *
   * @param {Object} {orderCode, newReserveDate, oldReserveDate} 订单号,新预约时间,旧预约时间
   * @return 是否修改成功
   *
   * @memberOf api
   */
  changeReserve({
    orderCode,
    newReserveDate,
    oldReserveDate
  }) {
    return this.get('/es/hms/order/change_reserve', {
      orderCode,
      newReserveDate,
      oldReserveDate
    })
  }

  /**
   * 获取家属套餐活动Code
   */
  getFamilyActivityCode() {
    return this.post('/es/hms/query/family_activity_code')
  }

  // 查询配置信息
  queryPartnerPage(data) {
    return this.get('/es/exam/query/partner_page', data)
  }

  // 体检预约new
  examReserve(data) {
    return this.post('/es/hms/order/examReserve', data)
  }

  /**
   * 带埋点的登录方式
   * @param data
   * @returns {*}
   */
  saLogin(data) {
    return this.post('/es/hms/login/saLogin', data)
  }

  // 前往支付时，获取用户的免登录态
  getUser(data, payLink) {
    this.get('/es/user/pre_query', data).then(res => {
      if (res.data.SZ_HEAD.RESP_CODE === 'S0000') {
        window.location.replace(`${payLink}&user=${res.data.SZ_BODY.user}`)
      }
    }).catch(err => {
      console.warn(err);
    })
  }
}

export default api
